module.exports = __webpack_public_path__ + "static/img/5_1.6e9703b5.jpg";